import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { AvatarColors } from '../../data';

const isAlphaNumeric = (code) => (code >= 48 && code <= 57) || (code >= 65 && code <= 90) || (code >= 97 && code <= 122);

const getColor = (char) => AvatarColors[char];
const getInitialsAndColor = (text, contentBasedBG) => {
    let color = 'gray';
    if (typeof text === 'string') {
        const upper = text.toUpperCase();
        const arr = upper.split(' ');
        if (contentBasedBG) {
            const filtered = arr.filter((part) => isAlphaNumeric(part.charCodeAt(0)));
            const initialsNormalized = filtered
                .map((part) => part[0].extensions.latinize())
                .join('')
                .substr(0, 2);
            color = getColor(initialsNormalized[0]);
        }
        return {
            initials: arr
                .map((part) => part[0])
                .join('')
                .substr(0, 2),
            color
        };
    }
    return {
        color,
        initials: false
    };
};

const BaseAvatar = ({ text, type, children, contentBasedBG, className }) => {
    const { initials, color } = React.useMemo(() => getInitialsAndColor(text, contentBasedBG), [text, contentBasedBG]);
    return (
        <div className={cx('avatar', `avatar--${type}`, `avatar--color-${color}`, className)}>
            {initials ? children(initials) : text}
        </div>
    );
};

BaseAvatar.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    contentBasedBG: PropTypes.bool,
    type: PropTypes.string.isRequired,

};
BaseAvatar.defaultProps = {
    contentBasedBG: false,
};

export default BaseAvatar;